import React from 'react';
import { useVehicleImage } from './useVehicleImage';
import { useVehicleDetails } from './useVehicleDetails';
import { VehicleImageView } from '@cp-shared-10/apis';
import { VehicleDetailsAndImageUi } from './vehicle-details-and-image-ui';

type VehicleDetailsAndImageProps = {
    vin: string;
    encryptedVin: string;
    brandModelType?: string;
    licensePlate?: string;
    defaultView?: VehicleImageView;
};
export const VehicleDetailsAndImage: React.FC<VehicleDetailsAndImageProps> = ({
    vin,
    encryptedVin,
    brandModelType,
    licensePlate,
    defaultView = VehicleImageView.EXTERIOR_FRONT_LEFT,
}) => {
    const {
        data: vehicleImages,
        isLoading: isLoadingVehicleImage,
        loadingError: vehicleImageLoadingError,
    } = useVehicleImage(encryptedVin, defaultView);
    const {
        data: vehicleDetails,
        isLoading: isLoadingVehicleDetails,
        loadingError: vehicleDetailsLoadingError,
    } = useVehicleDetails(encryptedVin);

    return (
        <VehicleDetailsAndImageUi
            vin={vin}
            brandModelType={brandModelType}
            vehicleDetails={vehicleDetails}
            isLoadingVehicleDetails={isLoadingVehicleDetails}
            vehicleDetailsLoadingError={!!vehicleDetailsLoadingError}
            vehicleImages={vehicleImages}
            isLoadingVehicleImage={isLoadingVehicleImage}
            vehicleImageLoadingError={!!vehicleImageLoadingError}
            licensePlate={licensePlate}
            defaultView={defaultView}
        />
    );
};
